import Swiper, { A11y, Pagination } from 'swiper'

const contextual = document.querySelector('.contextual-publications .swiper-container') !== null;

if (contextual) {

    Swiper.use([ A11y, Pagination ]);

    let config = {
        spaceBetween: 30,
        watchOverflow: true, // default
    
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
    
        a11y: {
            enabled: true,
            paginationBulletMessage: 'Aller à la diapositive {{index}}',
        },
    }
    
    let swiper = new Swiper('.contextual-publications .swiper-container', config);
}
